import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"center-focus-strong"},"children":[{"tag":"circle","attrs":{"id":"fill2","cx":12,"cy":12,"r":3,"fill":"props.fillColor2"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 3H3V8M16 3H21V8M8 21H3V16M16 21H21V16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"circle","attrs":{"id":"stroke2","cx":12,"cy":12,"r":3,"stroke":"props.strokeColor2","strokeWidth":"props.strokeWidth"}}]}]};

const CenterFocusStrong = Vue.extend<IconProps>({
  name: 'CenterFocusStrongIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'center-focus-strong',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CenterFocusStrong;
